import { INACTIVE_LIMIT_UNITS } from '../../constants';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { Fieldset } from 'foundations-components/transitional/components/Fieldset';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { Image } from 'foundations-components/transitional/components/Image';
import { InputGroup } from 'foundations-components/transitional/components/InputGroup';
import { MultiColumn, MultiColumnGroup, MultiColumnItem } from 'foundations-components/transitional/components/MultiColumn';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import { Overlay } from 'foundations-components/transitional/components/Overlay';
import { Select } from 'foundations-components/transitional/components/Select';
import { Toggle } from 'foundations-components/transitional/components/Toggle';
//@ts-expect-error untyped
import boardTourImage from 'bender-url!crm-pipeline-board-settings-lib/images/board.svg';
import { H5 } from 'foundations-components/transitional/components/H5';
import isNumber from 'transmute/isNumber';
import { useBoardPanelPresentationContext } from '../context/BoardPanelPresentationContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const InactiveCardPreferences = () => {
  const {
    settings,
    updateDraft
  } = useBoardPanelPresentationContext();
  const inactiveCardInput = settings.inactiveCardPreferences.value;
  const hasInvalidInput = !isNumber(inactiveCardInput) || inactiveCardInput < 1;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(H5, {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "editCardsPanel.inactiveCardsSection.header"
      }), ' ', /*#__PURE__*/_jsx(HelpIcon, {
        alignWithText: true,
        title: /*#__PURE__*/_jsxs("span", {
          children: [/*#__PURE__*/_jsx(FormattedMessage, {
            message: "editCardsPanel.inactiveCardsSection.helpText"
          }), /*#__PURE__*/_jsx(Image, {
            src: boardTourImage,
            role: "img",
            paddingBlockStart: "200"
          })]
        }),
        tooltipPlacement: "bottom"
      })]
    }), /*#__PURE__*/_jsx(MultiColumn, {
      flush: true,
      children: /*#__PURE__*/_jsxs(MultiColumnGroup, {
        children: [/*#__PURE__*/_jsx(MultiColumnItem, {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "editCardsPanel.inactiveCardsSection.turnOnAndOff.description"
          })
        }), /*#__PURE__*/_jsx(MultiColumnItem, {
          children: /*#__PURE__*/_jsx(Toggle, {
            "aria-label": I18n.text('editCardsPanel.inactiveCardsSection.header'),
            "data-test-id": "inactive-is-turned-on-input",
            "data-selenium-checked": !settings.inactiveCardPreferences.isTurnedOff,
            size: "small",
            checked: !settings.inactiveCardPreferences.isTurnedOff,
            onChange: e => {
              updateDraft({
                inactiveCardPreferences: Object.assign({}, settings.inactiveCardPreferences, {
                  isTurnedOff: !e.target.checked
                })
              });
            }
          })
        })]
      })
    }), /*#__PURE__*/_jsx(Fieldset, {
      overlay: settings.inactiveCardPreferences.isTurnedOff ? /*#__PURE__*/_jsx(Overlay, {
        contextual: true,
        use: "light",
        width: 350
      }) : undefined,
      children: /*#__PURE__*/_jsxs(InputGroup, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "editCardsPanel.inactiveCardsSection.setLimit.header"
        }),
        "aria-label": I18n.text('editCardsPanel.inactiveCardsSection.setLimit.header'),
        use: "itemBoth",
        children: [/*#__PURE__*/_jsx(FormControl, {
          "aria-labelledby": "inactiveLimitInputLabel",
          error: hasInvalidInput,
          validationMessage: /*#__PURE__*/_jsx(FormattedMessage, {
            message: 'editCardsPanel.inactiveCardsSection.valueIsZeroError'
          }),
          children: /*#__PURE__*/_jsx(NumberInput, {
            "data-test-id": "inactive-limit-input",
            min: 0,
            max: 999,
            precision: 0,
            onChange: e => {
              const newValue = parseInt(e.target.value, 10);
              if (isNaN(newValue)) {
                return;
              }
              updateDraft({
                inactiveCardPreferences: Object.assign({}, settings.inactiveCardPreferences, {
                  value: newValue
                })
              });
            },
            value: inactiveCardInput
          })
        }), /*#__PURE__*/_jsx(FormControl, {
          "aria-labelledby": "inactiveLimitInputLabel",
          children: /*#__PURE__*/_jsx(Select, {
            "data-test-id": "inactive-limit-unit-input",
            options: [{
              value: INACTIVE_LIMIT_UNITS.DAYS,
              text: I18n.text('editCardsPanel.inactiveCardsSection.units.days', {
                count: inactiveCardInput || 0
              })
            }, {
              value: INACTIVE_LIMIT_UNITS.WEEKS,
              text: I18n.text('editCardsPanel.inactiveCardsSection.units.weeks', {
                count: inactiveCardInput || 0
              })
            }],
            clearable: false,
            onChange: e => updateDraft({
              inactiveCardPreferences: Object.assign({}, settings.inactiveCardPreferences, {
                unit: e.target.value
              })
            }),
            value: settings.inactiveCardPreferences.unit
          })
        })]
      })
    })]
  });
};